<mat-checkbox
  [id]="id"
  class="field-checkbox"
  [formlyAttributes]="field"
  [tabIndex]="props.tabindex"
  [color]="defaultOptions.props.color"
  [labelPosition]="defaultOptions.props.labelPosition"
  [formControl]="formControl"
  >I have read and agree
</mat-checkbox>

<ul class="ml-7 list-inside list-[lower-roman] space-y-3 mt-3">
  <li>
    To submit my
    <a
      href="assets/core/pdfs/Terms_and_Condition.pdf"
      class="text-primary underline"
      target="_blank"
      >declaration</a
    >
    for this financing application with/without account opening.
  </li>
  <li>
    Reviewed the loans (<a
      href="https://www.cimb.com.sg/en/business/help-support/general-terms-and-conditions.html"
      class="text-primary underline"
      target="_blank"
      >terms and condition</a
    >), deposits (<a
      href="https://www.cimb.com.sg/en/business/help-support/general-terms-and-conditions.html"
      class="text-primary underline"
      target="_blank"
      >terms and condition</a
    >) and agree that an account will be opened upon acceptance of Letter of Offer for CIMB SME Loan.
  </li>
  <li>
    To be bound by the terms of
    <a
      href="https://www.cimb.com.sg/content/dam/cimbsg/business/documents/regulations-policies/personal-data-protection-act/pdpa-data-protection-policy.pdf"
      class="text-primary underline"
      target="_blank"
      >CIMB Data Protection Policy</a
    >
  </li>
</ul>
